var t=t=>!!t&&0===Object.keys(t).length&&t.constructor===Object;export{t as default};